import React from "react";
import { Routes, Route } from "react-router-dom";
import MainLayout from "./components/MainLayout";
import HomePage from "./pages/HomePage";
import PhotoGallery from "./pages/PhotoGallery";
import Media from "./pages/Media.js";
import MyFeed from "./pages/MyFeed.js";
import Settings from "./pages/Settings";
import RegisterPage from "./pages/RegisterPage"
import SearchPage from "./pages/SearchPage"
import WorldPage from "./pages/WorldPage"
import UserProfilePage from "./pages/UserProfilePage"
import TagPage from "./pages/TagPage"
import RecommendedPage from "./pages/RecommendedPage"
import PostDetailPage from "./pages/PostDetailPage"
import PeoplePage from "./pages/PeoplePage"
import DirectMessagesPage from "./pages/DirectMessagesPage"
import AgentPersonaPage from "./pages/AgentPersonaPage"
import { Toaster } from "react-hot-toast"
import EnvironmentBadge from './components/EnvironmentBadge';

function App() {
  return (
    <>
      {/* 개발(.kr / dev.*)에서만 뜬다. 운영에서는 아무것도 그리지 않는다. */}
      <EnvironmentBadge />
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#1f2937',
            color: '#fff',
            fontSize: '14px',
            borderRadius: '8px',
            padding: '12px 16px',
          },
          success: { iconTheme: { primary: '#10b981', secondary: '#fff' } },
          error: { iconTheme: { primary: '#ef4444', secondary: '#fff' } },
        }}
      />
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<HomePage />} />
          <Route path="search" element={<WorldPage />} />
          <Route path="search-old" element={<SearchPage />} />
          <Route path="photos" element={<PhotoGallery />} />
          <Route path="media" element={<Media />} />
          <Route path="feed" element={<MyFeed />} />
          <Route path="settings" element={<Settings />} />
          <Route path="settings/agent-personas" element={<AgentPersonaPage />} />
          <Route path="recommended" element={<RecommendedPage />} />
          <Route path="post/:id" element={<PostDetailPage />} />
          <Route path="posts/:id" element={<PostDetailPage />} />
          <Route path="profile/:username" element={<UserProfilePage />} />
          <Route path="tags/:tagName" element={<TagPage />} />
          <Route path="people" element={<PeoplePage />} />
          <Route path="messages" element={<DirectMessagesPage />} />
          <Route path="messages/:conversationId" element={<DirectMessagesPage />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
